<template>
  <BField
    :label="label"
    :type="{ 'is-error': getValidation.invalid }"
    :message="getValidation.message"
  >
    <BDatepicker
      v-model="localValue"
      v-validate="validation"
      class="ls-datepicker"
      :placeholder="placeholder"
      :min-date="minDate"
      :max-date="maxDate"
      :unselectable-days-of-week="unselectableDaysOfWeek"
      :icon="getValidation.invalid ? 'replaceCalendarError' : 'replaceCalendar'"
      :mobile-native="false"
      :name="name"
      test-id="ls-datepicker"
      :date-formatter="formatDate"
      :disabled="disabled"
      :inline="inline"
    />
  </BField>
</template>

<script>
import moment from 'moment';
import {
  lsFilters,
  lsPropTypeHelpers,
  lsTrackingService,
  lsValidationService,
} from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';

export default {
  name: 'LsDatepicker',
  inject: ['$validator'],
  props: {
    value: VueTypes.any.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    label: VueTypes.string,
    placeholder: VueTypes.string.def('- Select -'),
    validation: VueTypes.object.def(_.constant(null)),
    disabled: VueTypes.bool.def(false),
    inline: VueTypes.bool.def(false),
    minDate: VueTypes.instanceOf(Date).def(() => {
      return moment()
        .startOf('day')
        .toDate();
    }),
    maxDate: VueTypes.instanceOf(Date).def(() => {
      return moment()
        .startOf('day')
        .add(1, 'year')
        .toDate();
    }),
    unselectableDaysOfWeek: VueTypes.array,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
    getValidation() {
      return lsValidationService.getValidation.call(this);
    },
  },
  methods: {
    formatDate(date) {
      return lsFilters.date({ date });
    },
  },
};
</script>

<style lang="scss">
.ls-datepicker {
  .pagination-next {
    border-radius: 0;
    border-color: $primary;
  }

  .pagination-previous {
    border-radius: 0;
    border-color: $primary;
  }

  // fix weird bug that cropped up with Buefy 0.73
  // likely after this https://github.com/buefy/buefy/issues/1177
  .datepicker-content {
    height: 21.25rem;
  }

  .mdi-replaceCalendar::after {
    content: url(calendar.svg);
    position: absolute;
    top: 7px;
    right: 8px;
  }

  .mdi-replaceCalendarError::after {
    content: url(calendarError.svg);
    position: absolute;
    top: 7px;
    right: 8px;
  }

  .mdi-chevron-left::after {
    content: url(chevron.svg);
    position: absolute;
    top: -1px;
    left: 4px;
    transform: rotate(180deg);
  }

  .mdi-chevron-right::after {
    content: url(chevron.svg);
    position: absolute;
    top: 5px;
    left: 4px;
  }
}

.themed-app .ls-datepicker {
  .pagination-next,
  .pagination-previous,
  select,
  .select:not(.is-multiple):not(.is-loading):not(.is-error)::after {
    border-color: $theme-color-primary;
  }

  .datepicker-body a.datepicker-cell.is-selected {
    background-color: $theme-color-primary;
  }

  .mdi-replaceCalendar::after {
    background-color: $theme-color-primary;
    content: '';
    height: 16px;
    mask: url(calendar.svg);
    width: 16px;
  }

  .mdi-chevron-left::after {
    top: 5px;
  }

  .mdi-chevron-left::after,
  .mdi-chevron-right::after {
    background-color: $theme-color-primary;
    content: '';
    height: 20px;
    mask: url(chevron.svg);
    width: 20px;
  }
}
</style>
